import PropTypes from 'prop-types';
import { prop } from 'ramda';
import { Component } from 'react';
import { connect } from 'react-redux';

import './App.module.scss';

import * as VmsState from './backend/index-vms-state';
import Playground from './playground/Playground.jsx';
import Dashboard from './views/dashboard/Dashboard.jsx';
import Login from './views/login/Login.jsx';
import CommandLineToolsView from './views/command-line-tools-view';

const { Routing } = VmsState;

//Subscribe to this change in state, and update the Appinsights SDK with that info every time.
const SCENES = {
    [Routing.ROUTE_TYPES.LOGIN]: Login,
    [Routing.ROUTE_TYPES.PLAYGROUND]: Playground,
    [Routing.ROUTE_TYPES.VENUE]: Dashboard,
    [Routing.ROUTE_TYPES.VENUES]: Dashboard,
    [Routing.ROUTE_TYPES.POI]: Dashboard,
    [Routing.ROUTE_TYPES.DASHBOARD]: Dashboard,
    [Routing.ROUTE_TYPES.MAPNOTE]: Dashboard,
    [Routing.ROUTE_TYPES.IMPORT_EXPORT]: Dashboard,
    [Routing.ROUTE_TYPES.ERROR_PAGE]: Dashboard,
    [Routing.ROUTE_TYPES.MOD_WIZARD]: Dashboard,
    [Routing.ROUTE_TYPES.VISITOR_INSIGHTS]: Dashboard,
    [Routing.ROUTE_TYPES.SPATIAL_INSIGHTS]: Dashboard,

    // develop only
    [Routing.ROUTE_TYPES.COMMAND_LINE_TOOLS]: CommandLineToolsView,
};

class App extends Component {
    static propTypes = {
        initialized: PropTypes.bool,
        dispatch: PropTypes.func,
        Scene: PropTypes.object,
    };

    render() {
        const { initialized, dispatch, Scene } = this.props;
        const initialize = () => {
            dispatch(VmsState.MultiThunks.initializeApp());
            return null;
        };

        const goToLogin = () => {
            setTimeout(() => dispatch(Routing.Actions.goToLogin()), 0);
            return null;
        };

        if (!initialized) return initialize();
        if (!Scene) return goToLogin();
        return <Scene />;
    }
}

// :: String -> Component|undefined
const getScene = state => prop(Routing.Selectors.getLocationType(state), SCENES);

const mapStateToProps = state => ({
    initialized: VmsState.SessionReducer.Selectors.isSessionInitialized(state),
    Scene: getScene(state),
});

export default connect(mapStateToProps)(App);
